module.exports = __webpack_public_path__ + "media/images/mobile/solutions/ETS-IT-Photomock-4f4ddef9fe827914a9bb31de2a196b34.jpg";